import { useCallback, useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

export const FiacaoTempoReal = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(() => {
        setLoading(true);
        api.get('fiacao-tempo-real').then(response => {
            setData(response.data);
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            setData([]);
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if(loading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Card
                className="p-m-1"
                title="Últimos Paletes Cadastrados"
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button 
                        className="p-button-primary p-m-1"
                        icon="pi pi-refresh"
                        onClick={fetchData}
                    />
                </div>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header='Máquina' field="maquina" sortable />
                    <Column header='Título' field="descricao" sortable />
                    <Column header='Data Inicial' field="dataf" sortable />
                </DataTable>
            </Card>
        </div>
    )
}